import React, { useEffect, useState } from "react";

const CountDownTimer = ({ initialSeconds }) => {
  const [totalSeconds, setTotalSeconds] = useState(initialSeconds);

  useEffect(() => {
    if (totalSeconds <= 0) return;

    const interval = setInterval(() => {
      setTotalSeconds((prev) => prev - 1);
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [totalSeconds]);

  const days = Math.floor(totalSeconds / (24 * 60 * 60)); // 86400
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return (
    <ul style={{ padding: "0", margin: "0" }} className="sales-timer-wrapper">
      <div className="sales-time">
        <div className="sales-label">{days}</div>
        <span>Days</span>
      </div>

      <div className="colon">:</div>

      <div className="sales-time">
        <div className="sales-label">{hours}</div>
        <span>Hrs</span>
      </div>

      <div className="colon">:</div>

      <div className="sales-time">
        <div className="sales-label">{minutes}</div>
        <span>Mins</span>
      </div>

      <div className="colon">:</div>

      <div className="sales-time">
        <div className="sales-label">{seconds}</div>
        <span>Secs</span>
      </div>
    </ul>
  );
};

export default CountDownTimer;
